"use client";

import React from "react";
import Link from "next/link";
import Image from "next/image";
import { Compass } from "lucide-react";
import { FOOTER_CLUSTERS } from "@/config/navigation";
import { SITE_CONFIG } from "@/config/site";

export default function Footer() {
  return (
    <footer className="border-t border-border/60 bg-card/60 backdrop-blur-md pt-16 pb-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 lg:gap-8 pb-12 border-b border-border/60">
          {/* Brand Col */}
          <div className="lg:col-span-1 space-y-4">
            <Link href="/" className="flex items-center group shrink-0 inline-block transition-transform duration-200 hover:scale-105 mb-2">
              <Image
                src="/images/Logo/logo-light.png"
                alt="Name Arcane"
                width={200}
                height={28}
                className="h-8 sm:h-9 w-auto object-contain dark:hidden"
              />
              <Image
                src="/images/Logo/logo-dark.png"
                alt="Name Arcane"
                width={200}
                height={28}
                className="h-8 sm:h-9 w-auto object-contain hidden dark:block"
              />
            </Link>
            <p className="text-xs text-muted-foreground leading-relaxed">
              The premier arcane lore and name generator for novelists, D&D masters, and worldbuilders. Crafted by creator &amp; worldbuilding enthusiast <strong className="text-foreground">Paul Arcane</strong>.
            </p>
            <div className="pt-2 flex flex-col gap-2">
              <Link
                href="/directory"
                className="inline-flex items-center gap-1.5 text-xs font-semibold text-primary hover:underline"
              >
                <Compass className="w-3.5 h-3.5" />
                <span>Master A-Z Directory &rarr;</span>
              </Link>
            </div>
          </div>

          {/* 4 Topic Clusters from config */}
          {FOOTER_CLUSTERS.map((cluster) => (
            <div key={cluster.title}>
              <h2 className="text-xs font-bold uppercase tracking-wider text-foreground mb-4 font-fantasy">
                {cluster.title}
              </h2>
              <ul className="space-y-2 text-xs">
                {cluster.links.map((link) => (
                  <li key={link.href + link.label}>
                    <Link
                      href={link.href}
                      className="text-muted-foreground hover:text-primary transition-colors block truncate"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom copyright & Essential Pages */}
        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-muted-foreground">
          <p>© {new Date().getFullYear()} {SITE_CONFIG.name}. All rights reserved.</p>
          <div className="flex flex-wrap items-center gap-4">
            <Link href="/about" className="hover:text-primary font-medium transition-colors">
              About Paul Arcane
            </Link>
            <Link href="/contact" className="hover:text-primary font-medium transition-colors">
              Contact
            </Link>
            <Link href="/privacy" className="hover:text-primary font-medium transition-colors">
              Privacy Policy
            </Link>
            <Link href="/directory" className="hover:text-foreground transition-colors">
              Directory
            </Link>
            <Link href="/favorites" className="hover:text-foreground transition-colors">
              Favorites
            </Link>
            <Link href="/sitemap.xml" className="hover:text-foreground transition-colors">
              Sitemap.xml
            </Link>
            <Link href="/robots.txt" className="hover:text-foreground transition-colors">
              Robots.txt
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
